import { ControlsRmpQuery } from 'src/graphql/_generated';

type IsControlLinked = (params: {
  controlId: string;
  controlsRmp: ControlsRmpQuery['controls'];
  scenarioId: string;
  control_identifier?: string | null;
}) => boolean;

export const isControlLinked: IsControlLinked = ({ controlId, controlsRmp, scenarioId, control_identifier }) => {
  return controlsRmp.some((control) => {
    const isLinkedToScenario = control.riskManagementPlans.some((plan) => plan.scenario?.id === scenarioId);
    if (!isLinkedToScenario) return false;

    if (control.id === controlId) {
      return true;
    }

    const frameworkControls = control.frameworkControls || [];
    for (const el of frameworkControls) {
      const rmpFrameworkLibraryId = el?.control_identifier;
      if (rmpFrameworkLibraryId) {
        if (control_identifier && rmpFrameworkLibraryId === control_identifier) {
          return true;
        }

        if (rmpFrameworkLibraryId === controlId) {
          return true;
        }
      }
    }

    return false;
  });
};
